import { Button } from '@/components/ui/button';
import { Text, VerticalLayout } from 'widgets';

import { AuthenticationPage } from './AuthenticationPage';

interface Props {
    onSignOut: () => void;
}

export const NoTenantAccess = ({ onSignOut }: Props) => (
    <AuthenticationPage title="No tenant assigned">
        <VerticalLayout $gap={16} $columnCenter>
            <Text>
                Your account is signed in, but it does not have access to a tenant. Please contact your administrator to
                request access.
            </Text>
            <Button variant="highlighted" size="lg" onClick={onSignOut}>
                Sign out
            </Button>
        </VerticalLayout>
    </AuthenticationPage>
);
